export default __webpack_public_path__ + "static/20-f717206b7bad432c8e2ab3370e40cc85.jpg";